/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState, useEffect } from 'react';
import { Section } from '@spotahome/ui-library';
import { trans } from '@spotahome/soyuz/client';

import { LANDING_SECTIONS } from '@spotahome/ui-library/src/tenant/components/utils/seoConstants';
import { useMediaQuery } from '@spotahome/ui-library/src/tenant/components/utils/breakpoints/breakpoints';
import withInViewEvent from '@spotahome/ui-library/src/tenant/components/withInViewEvent';

import {
  MultipleItemsCarousel,
  CarouselArrows
} from '../MultipleItemsCarousel';

import PropertyTypeSectionCard from './PropertyTypeSectionCard';

import './PropertyTypeSection.scss';

const NUMBER_OF_ITEM_PER_SWIPE_MOBILE = 1;
const NUMBER_OF_ITEM_PER_SWIPE_PHABLET = 2;
const NUMBER_OF_ITEM_PER_SWIPE_TABLET = 3;
const NUMBER_OF_ITEM_PER_SWIPE_DESKTOP = 4;
const PROPERTY_TYPES = ['apartments', 'sharedRoom', 'studio', 'privateRoom'];

const PropertyTypeSection = () => {
  const [page, setPage] = useState(0);

  const mediaQueries = useMediaQuery();

  const getNumberOfItems = () => {
    if (mediaQueries.isBiggerThanTablet()) {
      return NUMBER_OF_ITEM_PER_SWIPE_DESKTOP;
    } else if (mediaQueries.isBiggerThanPhablet()) {
      return NUMBER_OF_ITEM_PER_SWIPE_TABLET;
    } else if (mediaQueries.isBiggerThanMobile()) {
      return NUMBER_OF_ITEM_PER_SWIPE_PHABLET;
    } else if (
      mediaQueries.isMobileScreen() ||
      mediaQueries.isPhabletScreen()
    ) {
      return NUMBER_OF_ITEM_PER_SWIPE_MOBILE;
    }

    // default
    return NUMBER_OF_ITEM_PER_SWIPE_DESKTOP;
  };

  const numberOfItems = getNumberOfItems();

  const getSlidePercentage = () =>
    mediaQueries.isBiggerThanTablet() ? 100 : 80;

  const maxPage = Math.round(PROPERTY_TYPES.length / numberOfItems);

  useEffect(() => {
    setPage(0);
  }, [mediaQueries.device]);

  const renderCarouselItem = type => (
    <PropertyTypeSectionCard type={type} key={type} isRedesign />
  );

  return (
    <Section background="light" className="property-type-section__container">
      <div className="property-type-section">
        <div className="property-type-section__header">
          <h2 className="property-type-section__header-title">
            {trans('landingpage.label.propertyTypes')}
          </h2>
          {!mediaQueries.isBiggerThanTablet() && (
            <span className="property-type-section__arrows">
              <CarouselArrows page={page} setPage={setPage} maxPage={maxPage} />
            </span>
          )}
        </div>
        <div className="property-type-section__carousel">
          <MultipleItemsCarousel
            items={PROPERTY_TYPES.map(renderCarouselItem)}
            itemsPerSwipe={numberOfItems}
            selectedPage={page}
            centerItems={!!mediaQueries.isBiggerThanLaptop()}
            slidePercentage={getSlidePercentage()}
          />
        </div>
      </div>
    </Section>
  );
};

export default withInViewEvent(LANDING_SECTIONS.propertyType)(
  PropertyTypeSection
);
